var site = site || {};
(function($) {
  Drupal.behaviors.trendReportTrueFalseFormatterV1 = {
    attached: false,
    attach: function(context) {
      if (this.attached) {
        return;
      }
      this.attached = true;
      var $module = $('.js-trend-report-truefalse-formatter-v1', context);
      var $next = $module.find('.js-trend-report-truefalse__answer-cta');
      var $back = $module.find('.js-trend-report-truefalse__answer-back');
      var $questions = $module.find('.js-trend-report-true-false');
      var $answer = $module.find('.js-trend-report-truefalse__answer');
      var counter = 1;

      function fireAnalytic(eventAction, eventLabel) { // GA
        if (site && site.track) {
          site.track.evtLink({
            event_name: 'elTrueFalseQuiz',
            event_category: 'True False Quiz',
            event_action: eventAction,
            event_label: eventLabel
          });
        }
      }

      $.each($questions, function(index, value) {
        if (index > 0) { // Hide all questions except for the first one
          $(value).addClass('trend-report-truefalse_hide');
        }
        if (index === 0) {
          $(value).addClass('active');
        }
      });

      $next.off('click').on('click', function() { // On click of next button, hide current question and show the next question
        var total = $questions.length;
        $answer.removeClass('trend-report-truefalse__answer--show');
        $.each($questions, function(index, value) {
          if ($(value).hasClass('active')) {
            var $questCurrent = $(value);
            $questCurrent.addClass('trend-report-truefalse_hide');
            $questCurrent.removeClass('active');
            fireAnalytic('Next Button - Question Number', counter);
            counter++;
            if (index < total - 1) {
              var $nextQ = $($questions[index + 1]);
              $nextQ.removeClass('trend-report-truefalse_hide');
              $nextQ.addClass('active');
              return false;
            } else {
              $($questions[0]).removeClass('trend-report-truefalse_hide');
              $($questions[0]).addClass('active');
            }
          }
        });
      });

      $back.off('click').on('click', function() { // On click of back button, hide current question and show the previous question
        var total = $questions.length;
        $answer.removeClass('trend-report-truefalse__answer--show');
        $.each($questions, function(index, value) {
          if ($(value).hasClass('active')) {
            var $questCurrent = $(value);
            $questCurrent.addClass('trend-report-truefalse_hide');
            $questCurrent.removeClass('active');
            fireAnalytic('Back Button - Question Number', counter);
            counter++;
            if (index <= total - 1) {
              index = index - 1;
              if (index < 0) {
                index = 0;
              }
              var $backQ = $($questions[index]);
              $backQ.removeClass('trend-report-truefalse_hide');
              $backQ.addClass('active');
              return false;
            } else {
              $($questions[0]).removeClass('trend-report-truefalse_hide');
              $($questions[0]).addClass('active');
            }
          }
        });
      });
    }
  };
})(jQuery);
